import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

const SaveButton = ({ hasChanges, onSave }) => {
  return (
    <Flex justify="flex-end" mt={6}>
      <Button
        size="lg"
        colorScheme={hasChanges ? 'blue' : 'gray'}
        isDisabled={!hasChanges}
        onClick={onSave}
        px={8}
        width="20%"
      >
        Update
      </Button>
    </Flex>
  );
};

export default SaveButton;
